import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {IconButton} from '../../../../../../libs/shared/ui/src/components/buttons/iconButton';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {flexCenter} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {useClipboard} from '../../../../../helpers/hooks/clipboardHookHelpers';
import {SidePanelSubSectionWrapper} from '../sidePanelSubSectionWrapper';

/*
 * Props.
 */

interface SummaryConversationIdProps {
  conversationId: string;
}

/*
 * Styles.
 */

const StyledConvIdWrapper = styled.div`
  ${flexCenter};
  justify-content: space-between;
`;

/*
 * Component.
 */

export const SummaryConversationId: FC<SummaryConversationIdProps> = ({conversationId}) => {
  const theme = useUserTheme();
  const {copy} = useClipboard();

  return (
    <SidePanelSubSectionWrapper
      title={<Trans id="analytics-drawer-details-conversation-id">Conversation ID</Trans>}
    >
      <StyledConvIdWrapper>
        {conversationId}
        <IconButton
          size={VisualSizesEnum.SMALL}
          color={theme.greys.shade50}
          iconName="copySmall"
          label={<Trans id="analytics-drawer-details-copy-conversation-id">Copy ID</Trans>}
          onClick={() => copy(conversationId)}
        />
      </StyledConvIdWrapper>
    </SidePanelSubSectionWrapper>
  );
};
